import '../../capabilities/registry';
import { registerDeployPlugin } from '../../core/registry';
import { registerResourceConfigs } from '../../platform/resource-watch';
import { registerSkuModuleMeta } from '../../platform/scene-layout/moduleMetaRegistry';
import { vmHeadless } from './headless';
import { VM_RESOURCE_CONFIGS, VM_SKU_MODULE_META } from './resourceConfigs';

registerSkuModuleMeta('VirtualMachine', VM_SKU_MODULE_META);
registerResourceConfigs('VirtualMachine', VM_RESOURCE_CONFIGS);

registerDeployPlugin({
  headless: vmHeadless,
  loadUi: () =>
    import('./ui').then((m) => ({
      ResourceEditor: m.VmResourceEditor,
      ResourcePreview: m.VmResourcePreview,
    })),
});

export { hydrateVirtualMachineDetailToForm } from './hydrateFromApiDetail';
export { VM_CAPABILITIES, VM_MODULES, VM_MODULE_MAP } from './modules';
export {
  VM_RESOURCE_CONFIGS,
  VM_SKU_MODULE_META,
  resolveVmPricingResourceCodes,
  resolveVmResourceWatchFields,
  vmBandwidth,
  vmComputeTemplates,
  VM_COMPUTE_RESOURCE_CODES,
  vmCpu,
  vmDataStorage,
  vmGpu,
  vmMemory,
  vmSystemStorage,
} from './resourceConfigs';
export { VM_FIELD_KEYS } from './fields';
export type { VmFieldKey } from './fields';
export { resetVmSkuModuleFields } from './skuModuleReset';
export {
  VM_SCENES,
  VM_ALL_MODULES,
  VM_SKU_MODULES,
  VM_SKU_MODULE_LIST,
  filterVmSkuModules,
  isVmSkuModuleKey,
  VM_ORDER_MODULES,
  VM_DIRECT_CREATE_STEPS,
  VM_DIRECT_MERGED_MODULES,
  filterVmDirectMergedModules,
  buildVmDirectResourceModulesFromForm,
  resolveVmSceneConfig,
} from './scenes';
export type { VmDirectCreateStep, VmDirectMergedModuleKey, VmSkuModuleKey } from './scenes';
export {
  buildVmFreshDisplayConfig,
  filterVmProductCardDisplayConfig,
  finalizeVmSubmitDisplayConfig,
  isVmProductCardDisplayId,
  VM_PRODUCT_CARD_DISPLAY_IDS,
} from './display';
export { buildVmMergedDisplayConfig } from './display/mergeDisplayConfig';
export { buildVmSkuCapabilityOptions } from './skuCapabilityOptions';
export {
  VM_ORDER_PREVIEW_EXTRA_WATCH_FIELDS,
  VM_ORDER_INNER_ROOT_WATCH_FIELDS,
  VM_SKU_PREVIEW_EXTRA_WATCH_FIELDS,
  resolveVmSkuPreviewExtraWatchFields,
  resolveVmOrderPreviewExtraWatchFields,
  resolveVmOrderInnerRootWatchFields,
} from './orderPreviewWatch';
export {
  applyVmWorkspaceFormFields,
  buildVmDeliveryMetadata,
  buildVmOrderDeliveryMetadata,
  finalizeVmDeliveryMetadata,
  resolveVmWorkspaceFromApi,
} from './headless/deliveryMetadata';
export type { BuildVmDeliveryMetadataInput, BuildVmOrderDeliveryMetadataContext, VmDeliveryMetadata } from './headless/deliveryMetadata';
export { VmResourceEditor, useVmDeployFormLinkage } from './ui/ResourceEditor';
export type { VmResourceEditorProps } from './ui/ResourceEditor';
export { VmResourcePreview } from './ui/ResourcePreview';
export type { VmLinkagePropsMap } from './linkage';
